/* eslint-disable */
(function() {
	if (typeof globalThis === 'object') return;
	Object.defineProperty(Object.prototype, '__magic__', {
		get: function() {
			return this;
		},
		configurable: true,
	});
	__magic__.globalThis = __magic__;
	delete Object.prototype.__magic__;
})();

import '@babel/polyfill';
import 'es6-promise/auto';
import 'url-polyfill';
import './gnb';
import './footer';
import '@/helpers/anchorUrlChange'; // only for nexon.net cross domain support
